export default __webpack_public_path__ + "static/media/techx.e039ab71.svg";